<template>
  <div class="mt-4 mt-md-5 text-center">
    <p class="mb-0">
      {{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © Sellerdesk.ai
    </p>
  </div>
</template>

<script>
export default {
  name: "LoginFooter"
}
</script>

<style scoped>

</style>